import {Component, inject, Input} from "@angular/core";
import {SelectionService} from "src/app/services/selection.service";

@Component({
  selector: "app-nav-link",
  template: `
    <li class="nav-item">
      <a
        class="nav-link py-3 border-bottom"
        [routerLink]="link"
        [ngClass]="{ expanded: isExpanded }"
        [style.--activeColor]="activeColor"
        (click)="onClick()"
      >
        <i class="bi {{ icon }} h4" [ngClass]="{ activeItem: isActive }"></i>
        <span class="link-text ms-2">{{ title }}</span>
      </a>
    </li>
  `,
  styles: [
    `
      i {
        color: black;
      }

      .link-text {
        display: none;
      }

      .expanded .link-text {
        display: inline
      }

      .activeItem {
        color: var(--activeColor)
      }
    `]

})
export class NavLinkComponent {
  @Input() link: string = "";
  @Input() icon: string = "";
  @Input() title: string = "";
  @Input() isActive: boolean = false;
  @Input() activeColor: string = '#198AE3'
  @Input() isExpanded: boolean = false;

  selectionService = inject(SelectionService);

  onClick() {
    this.selectionService.changeActivePage(0);
  }
}
